<template>
  <div class="product-detail">
    <drug-guide title="产品中心" :headimg="proHead" :enimg="enImg"></drug-guide>
    <div class="prodetail">
      <div class="prodetail-good">
        <div class="progood-img">
          <img class="progood-bg" :src="goodBg" alt="">
          <img class="progood-shop" :src="detail.thumb" alt="">
        </div>
        <div class="progood-con">
          <div class="progood-title">{{ detail.title }}</div>
          <div class="progood-type">{{ detail.cate_name }}</div>
          <div class="progood-label">{{ detail.bref }}</div>
        </div>
      </div>
      <div class="prodetail-con" v-html="detail.content"></div>
      <div class="prodetail-page">
        <div class="prodetail-prev" :class="detail.prev_id ? '' : 'on'" @click="getPrev(detail.prev_id)">上一篇</div>
        <div class="prodetail-return" @click="getReturn()">返回列表</div>
        <div class="prodetail-next" :class="detail.next_id ? '' : 'on'" @click="getNext(detail.next_id)">下一篇</div>
      </div>
    </div>
    <drug-footer></drug-footer>
  </div>
</template>

<script>
import DrugFooter from "../../components/DrugFooter";
import DrugGuide from "../../components/DrugGuide";
import { getDetail } from "@/api/index";
export default {
  name: "ProductDetail",
  components: {
    DrugFooter,
    DrugGuide
  },
  data() {
    return {
      proHead: "static/images/production/pro-head.png",
      enImg: "static/images/production/pro-en.png",
      goodBg: "static/images/production/pro-goodbg.png",
      detail: {}
    }
  },
  created() {
    var id = this.$route.query.id;
    getDetail(id).then((res) => {
      if(res.data.code == 1) {
        this.detail = res.data.data;
      }
    })
  },
  watch: {
    "$route.query.id"() {
      document.documentElement.scrollTop = 0;
      var id = this.$route.query.id;
      getDetail(id).then((res) => {
        if(res.data.code == 1) {
          this.detail = res.data.data;
        }
      })
    }
  },
  methods: {
    // 上一篇
    getPrev(id) {
      if(id) {
        this.$nextTick(() => {
          this.$router.replace({
            path: "/production/detail",
            query: { id }
          }, () => {})
        })
      }
    },
    // 返回列表
    getReturn() {
      this.$router.replace({
        path: "/production"
      })
    },
    // 下一篇
    getNext(id) {
      if(id) {
        this.$nextTick(() => {
          this.$router.replace({
            path: "/production/detail",
            query: { id }
          }, () => {})
        })
      }
    }
  },
  mounted() {
    this.$store.commit("getactive", 2);
  }
}
</script>

<style lang="scss" scoped>
.product-detail {
  .prodetail {
    width: 80%;
    height: auto;
    overflow: hidden;
    background-color: #fff;
    margin: 20px auto 0 auto;
    padding: 20px;
    box-sizing: border-box;
    .prodetail-good {
      width: 100%;
      height: 260px;
      padding: 20px 0;
      display: flex;
      .progood-img {
        width: 30%;
        // height: 260px;
        margin-right: 60px;
        position: relative;
        padding: 30px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        .progood-bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 10;
        }
        .progood-shop {
          width: 90%;
          position: relative;
          z-index: 20;
        }
      }
      .progood-con {
        width: 60%;
        padding-top: 32px;
        .progood-title {
          height: 40px;
          line-height: 40px;
          font-size: 28px;
          font-family: "PingFang SC-Medium", "PingFang SC";
          font-weight: 500;
          color: #002244;
        }
        .progood-type {
          width: 90px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #fff;
          background: linear-gradient(270deg, #B1FAFF 0%, #4392EC 100%);
          margin: 20px 0 25px 0;
          border-radius: 0 0 10px 0;
        }
        .progood-label {
          width: 90%;
          font-size: 16px;
          font-weight: 400;
          color: #7C828A;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .prodetail-con {
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      padding: 50px;
    }
    .prodetail-page {
      cursor: pointer;
      padding: 37px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      color: #7C828A;
      font-size: 16px;
      div {
        border: 1px solid #ddd;
        height: 40px;
        line-height: 40px;
        padding: 0 36px;
        &.on {
          color: #cecece;
        }
      }
      .prodetail-return {
        margin: 0 20px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/production/detail.vue